import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import '../styles/ImageModal.css';

const ImageModal = ({ src, caption, onClose }) => {
  if (!src) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
        <img src={src} alt="preview" className="modal-img" />
        <div className="modal-caption">{caption}</div>
      </div>
    </div>
  );
};

export default ImageModal;
